import type { ReactNode } from 'react';

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="px-1 text-sm font-medium text-stone-600 dark:text-stone-400">{label}</span>
      {children}
    </label>
  );
}
